const defaultData = {
  sentiment: {
    level: "",
    emoji: "",
    message: "",
    color: "#ccc",
  },

  emailInfo: {
    from: "",
    email: "",
    phone: "",
    policyMentioned: "",
  },

  salesforceContext: {
    matchFound: true,
    contact: "John Smith",
    account: "Smith Household",
    clientSince: "March 2019",
    openCases: 0,
  },

  activePolicies: [
    {
      id: 1,
      type: "Auto Policy",
      icon: "🚗",
      status: "Active",
      policyNumber: "PA-2024-78432",
      carrier: "Progressive",
      premium: "$1,850/yr",
      expiration: "06/15/2026",
      details: "$500 Comp / $1,000 Collision Ded",
    },
    {
      id: 2,
      type: "Home Policy",
      icon: "🏠",
      status: "Active",
      policyNumber: "HO-2024-12890",
      carrier: "State Farm",
      premium: "$2,400/yr",
      expiration: "06/15/2026",
      details: "$1,000 Deductible",
    },
  ],

  crossSell: {
    count: 1,
    opportunities: [
      {
        id: 1,
        type: "Umbrella Policy",
        icon: "☂️",
        description:
          "Client has home + auto but no umbrella. With $300K+ in assets, recommend $1M umbrella for ~$350/yr.",
      },
    ],
  },

  userData: {
    email: "mock.user@example.com",
    name: "Mock Administrator",
    role: "admin",
  },

  analytics: {
    summary: {
      avgAnalysisMinutes: 1.4,
      emailsHandled: 128,
      detailedCompletionPercent: 92,
    },
    agents: [
      { key: "1", displayName: "John Doe", userEmail: "agent1@example.com", emailsHandled: 45, detailedCompletionPercent: 95, avgAnalysisMinutes: 1.2 },
      { key: "2", displayName: "Jane Smith", userEmail: "agent2@example.com", emailsHandled: 38, detailedCompletionPercent: 88, avgAnalysisMinutes: 1.6 },
      { key: "3", displayName: "Bob Johnson", userEmail: "agent3@example.com", emailsHandled: 45, detailedCompletionPercent: 93, avgAnalysisMinutes: 1.4 },
    ],
    categories: [
      { key: "c1", category: "Inquiry", emailsHandled: 50, detailedCompletionPercent: 90, avgAnalysisMinutes: 1.1 },
      { key: "c2", category: "Support", emailsHandled: 40, detailedCompletionPercent: 95, avgAnalysisMinutes: 1.8 },
      { key: "c3", category: "Claim", emailsHandled: 38, detailedCompletionPercent: 91, avgAnalysisMinutes: 1.3 },
    ],
  },

  userSettings: {
    apiConfiguration: {
      sfdcConsumerKey: "mock_consumer_key_xyz",
      sfdcConsumerSecret: "mock_consumer_secret_abc",
      masterSubscriptionEmail: "admin@agency.com",
    },
  },
};

export default defaultData;
